<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <br/>
            <div class="row form-group">
                <label class="col-sm-4 col-form-label text-capitalize text-right">ชื่อเครื่อง</label>
                <div class="col-sm-4 col-form-label">
                    <input class="form-control" v-model="form.name"/>
                </div>
            </div>
            <div class="row form-group">
                <label class="col-sm-4 col-form-label text-capitalize text-right">คำอธิบายเครื่อง</label>
                <div class="col-sm-4 col-form-label">
                    <textarea class="form-control" v-model="form.description"></textarea>
                </div>
            </div>
            <div class="col text-center">
                <button type="button" class="btn btn-success" @click="saveMachineSheet">
                    <icon name="save"></icon>
                    ตกลง
                </button>&nbsp;
                <button type="button" class="btn btn-outline-secondary" @click="goToMachineSheetList">
                    <icon name="times"></icon>
                    บันทึก
                </button>&nbsp;
                <button type="button" class="btn btn-danger" @click="showModalDelete">
                    <icon name="trash"></icon>
                    ลบ
                </button>&nbsp;
            </div>
            <!-- Modal Delete-->
            <b-modal hide-header hide-footer ref="delete_item">
                <div style="text-align: center;">
                    <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                    <br />
                    <button @click="deleteMachineSheet"
                            type="button"
                            class="btn btn-success">
                        ตกลง
                    </button>
                    &nbsp&nbsp
                    <button @click="hideModalDelete"
                            type="button"
                            class="btn btn-secondary">
                        ยกเลิก
                    </button>
                </div>
            </b-modal>
            <br/>
        </div>
        <!--<pre class="alert-primary">{{form}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    export default {
        name: "machine-sheet-form",
        data(){
            return{
                items: [
                    {
                        text: "รายการเครื่องผลิตชีท",
                        to: {name: "machine-sheet"}
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
            }
        },
        computed:{
            ...mapState({
                form :state=>{
                    return state.MachineSheet.form;
                }
            })
        },
        methods:{
            //Modal
            showModalDelete() {
                this.$refs.delete_item.show();
            },
            hideModalDelete() {
                this.$refs.delete_item.hide();
            },

            //API
            saveMachineSheet(){
                this.$store.dispatch("MachineSheet/saveMachine",this.form.id).then(()=>{
                    this.goToMachineSheetList();
                })
            },
            goToMachineSheetList(){
                this.$router.push("/machine-sheet")
            },
            deleteMachineSheet(){
                this.$store.dispatch("MachineSheet/deleteMachine",this.form.id).then(()=>{
                    this.hideModalDelete();
                    this.$store.dispatch("MachineSheet/getMachine")
                    this.goToMachineSheetList();
                })
            }
        }
    }
</script>

<style scoped>

</style>